import { render, staticRenderFns } from "./add-delivery-staff.vue?vue&type=template&id=e27303c8&scoped=true&"
import script from "./add-delivery-staff.vue?vue&type=script&lang=js&"
export * from "./add-delivery-staff.vue?vue&type=script&lang=js&"
import style0 from "./add-delivery-staff.vue?vue&type=style&index=0&id=e27303c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27303c8",
  null
  
)

export default component.exports